<template>
  <UModal title="Doneren">
    <template #body>
      <DonateContent class="m-4 grid gap-4" />
    </template>
    <slot />
  </UModal>
</template>
